export function init() {
  // Small screens search modal
  jQuery("#search-modal-toggle").click(function (e) {
    e.preventDefault();
    jQuery("#search-modal").fadeIn("slow");
  });
  jQuery("#search-modal-close").click(function (e) {
    e.preventDefault();
    jQuery("#search-modal").fadeOut("slow");
  });

  // Slide in Lemur when the section scrolls into view
  jQuery(window).scroll(function () {
    "use strict";

    // This is then function used to detect if the element is scrolled into view
    function elementScrolled(elem) {
      var docViewTop = jQuery(window).scrollTop();
      var docViewBottom = docViewTop + jQuery(window).height();
      var elemTop = jQuery(elem).offset().top;
      return elemTop <= docViewBottom && elemTop >= docViewTop;
    }

    if (!jQuery(".influence-stats").length == 0) {
      // This is where we use the function to detect if ".influence-stats" is scrolled into view, and when it is add the class ".animated" to the <p> child element
      if (elementScrolled(".influence-stats")) {
        var els = jQuery(".influence-stats img"),
          i = 0,
          f = function () {
            jQuery(els[i++]).addClass("animated animated-slide-in-left");
            if (i < els.length) setTimeout(f, 400);
          };
        f();
      }
    }
  });

  //slide in girrafe
  jQuery(".thank-you-giraffes img").addClass(
    "animated animated-slide-in-right",
  );
}
